import { IonCheckbox, IonContent, IonInput, IonLabel, IonPage, IonIcon } from "@ionic/react";
import { useEffect, useState } from "react";
import service from "../../../Service/service";
import Head from "../../Header";
import Select from "react-select"
import Sidebar from "../../Sidebar";
import swal from 'sweetalert';
import { useHistory } from "react-router";
import { searchOutline, chevronDownOutline } from "ionicons/icons";
const HRCreateEmployeee: React.FC = () => {
    const history = useHistory();
    //const [token] = useState(localStorage.getItem("SignupEmpId"));
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    //const [Id] = useState(localStorage.getItem("SignupEmpId"));

    /*............Mapping ............ */

    const inputArr = [
        {
            instituteName: "",
            university: "",
            degree: "",
            coreSubjects: "",
            yearOfPassing: "",
            gpa: "",
        }
    ];

    const inputArr1 = [
        {
            certificateName: "",
            descriptions: "",
            issuedBy: "",
            validity: "",
        }
    ];

    const inputArr2 = [
        {
            organization: "",
            designation: "",
            startyear: "",
            endyear: "",
        }
    ];

    const inputArr3 = [
        {
            technicalSkills: "",
            proficiency: "",
            yearsOfExperience: "",
        }
    ];

    const [collegeMap, setCollegeMap]: any = useState(inputArr)
    const [certificateMap, setCertificateMap]: any = useState(inputArr1)
    const [employmentDetailMap, setEmployeeDetailMap]: any = useState(inputArr2)
    const [techskillMap, setTechskillMap]: any = useState(inputArr3)

    /*........... View ............ */
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [designation, setDesignation]: any = useState([]);
    const [doj, setDoj] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [personalemail, setPersonalEmail] = useState("");
    const [DOB, setDOB] = useState("");
    const [gender, setGender]: any = useState([]);
    const [reportingPerson, setReportingPerson]: any = useState([]);
    const [contact, setContact] = useState("");
    const [bloodGroup, setBloodGroup]: any = useState([]);
    const [ERelationship, setERelationship] = useState("");
    const [martialStatus, setMaritialStatus]: any = useState([]);
    const [phone, setPhone] = useState("");
    const [Location, setLocation] = useState("");
    const [fathername, setFathername] = useState("");
    const [employeeStatus, setEmployeestatus] = useState("");
    const [category, setCategory]: any = useState([]);
    const [role, setRole] = useState("");
    const [pfNo, setPfNo] = useState("");
    const [esiNo, setEsiNo] = useState("");
    const [insurance, setInsurance] = useState("");
    const [insuranceValidity, setInsuranceValidity] = useState("");
    const [insuranceCoverage, setInsuranceCoverage] = useState("");
    const [insuranceRelation, setInsuranceRelation] = useState("");
    const [department, setDeapartment] = useState("");
    const [business, setBusiness] = useState("");
    const [aadhaar, setAadhaar] = useState("");
    const [panNo, setPanNo] = useState("");
    const [passport, setPassPort] = useState("");
    const [status,setstatus]=useState(true)
    const [passportValidity, setPassPortvalidity] = useState("");
    const [xthinstitute, setXthinstitute] = useState("");
    const [xthpassyear, setXthpassyear] = useState("");
    const [xthboard, setXthboard] = useState("");
    const [xthpercentage, setXthpercentage] = useState("");
    const [xiithinstitute, setXIIthinstitute] = useState("");
    const [xiithpassyear, setXIIthpassyear] = useState("");
    const [xiithcoresubject, setXIIthcoresubject] = useState("");
    const [xiithpercentage, setXIIthpercentage] = useState("");

    const inputArr4 = [
        {
            coverageName: "",
            relationship: "",
        }
    ]

    const [coverage, setCoverage] = useState(inputArr4)

    /*.............Unknown Variable ........... */

    const [che, setChe] = useState(false);
    const [idb, setidb] = useState("");
    const [data, setData]: any = useState([]);
    const [empCode, setEmpCode] = useState("");
    const [first, setFirst] = useState("");
    const [last, setLast] = useState("");

    /*.......... DropDown Mapping ............ */
    const [genderStatus, setGenderStatus]: any = useState([]);
    const [bloodGroupArr, setBloodGroupArr]: any = useState([]);
    const [martialArr, setMaritialArr]: any = useState([]);
    const [empCategory, setEmpCategory]: any = useState([]);
    const [empStatus, setEmpStatus]: any = useState([]);
    const [designationArr, setDesignationArr]: any = useState([]);
    const [managerArr, setManagerArr]: any = useState([]);
    const [businessUnitArr, setBusinessUnitArr] = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [proficiencyArr, setProficiencyArr]: any = useState([]);
    const [xboardArr, setXBoardArr]: any = useState([]);

    const [addressline1, setAddressline1] = useState('');
    const [addressline2, setAddressline2] = useState('');
    const [addressline3, setAddressline3] = useState('');
    const [addressline4, setAddressline4] = useState('');

    const [Peraddressline1, setPerAddressline1] = useState('');
    const [Peraddressline2, setPerAddressline2] = useState('');
    const [Peraddressline3, setPerAddressline3] = useState('');
    const [Peraddressline4, setPerAddressline4] = useState(''); 

    //**************Businessunit Autocomplete****************//
     
    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen1) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen1]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [

        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),

    ];


    const handleBusinessChange = (selectedOption: any) => {
        setBusiness(selectedOption.value)
        ViewAllDepartmentunit(selectedOption.value)

    };

     //**************Departmentunit Autocomplete****************//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholder1 = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Department Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const option1 = [

        ...departmentUnitArr.map((state: any) => ({
            value: state.id,
            label: state.departmentName,
        })),

    ];
    const handleDeptChange = (selectedOption1: any) => {
        setDeapartment(selectedOption1.value)
    };

 //**************Reporting Manager Autocomplete****************//

    const [selectedOption2, setSelectedOption2] = useState(null);
    const [inputValue2, setInputValue2] = useState('');
    const [isFocused2, setIsFocused2] = useState(false);
    const [menuIsOpen2, setMenuIsOpen2] = useState(false);

    const handleStateChange2 = (selectedOption2: any) => {
        setSelectedOption2(selectedOption2);
    };

    const handleInputChange2 = (inputValue2: any) => {
        setInputValue2(inputValue2);
    };

    const handleMenuOpen2 = () => {
        setMenuIsOpen2(true);
    };

    const handleMenuClose2 = () => {
        setMenuIsOpen2(false);
    };

    const handleFocus2 = () => {
        setIsFocused2(true);
    };

    const handleBlur2 = () => {
        setIsFocused2(false);
    };

    const Placeholder2 = () => {
        if (inputValue2 === '' && !selectedOption2 && !isFocused2) {
            return <span style={{ color: "black" }}>Select Reporting Manager</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const option2 = [
        ...managerArr.map((state: any) => ({
            value: state.id,
            label: state.name,
        })),

    ];
    const handleManagerChange = (selectedOption2: any) => {
        setReportingPerson(selectedOption2.value)
    };

 //**************Designation Autocomplete****************//

    const [selectedOption3, setSelectedOption3] = useState(null);
    const [inputValue3, setInputValue3] = useState('');
    const [isFocused3, setIsFocused3] = useState(false);
    const [menuIsOpen3, setMenuIsOpen3] = useState(false);

    const handleStateChange3 = (selectedOption3: any) => {
        setSelectedOption3(selectedOption3);
    };

    const handleInputChange3 = (inputValue3: any) => {
        setInputValue3(inputValue3);
    };

    const handleMenuOpen3 = () => {
        setMenuIsOpen3(true);
    };

    const handleMenuClose3 = () => {
        setMenuIsOpen3(false);
    };

    const handleFocus3 = () => {
        setIsFocused3(true);
    };

    const handleBlur3 = () => {
        setIsFocused3(false);
    };

    const Placeholder3 = () => {
        if (inputValue3 === '' && !selectedOption3 && !isFocused3) {
            return <span style={{ color: "black" }}>Select Designation</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator3: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);
        let icon
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }
        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const option3 = [
        ...designationArr.map((state: any) => ({
            value: state.id,
            label: state.designationName,
        })),

    ];
    const handleDesignation = (selectedOption3: any, i: any) => {
        setDesignation(selectedOption3.value)
        employmentDetailMap[i].designation = selectedOption3.value
    };
    /*............ Validation .......... */
    const mailPat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const namepat = /^[a-zA-Z\s]*$/;
    const passvalidation = /^(?=.*[0-9])(?=.*[A-Z]).{8,16}$/;
    const regsaid = /[a-zA-Z]{2}[0-9]{7}/;

    const [visible, setVisible] = useState(0);

    const toggleDiv = () => {
        setVisible(0);
    }

    const toggleDiv1 = () => {
        if (idb != "") {
            setVisible(1);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const toggleDiv2 = () => {
        if (idb != "") {
            setVisible(2);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const toggleDiv3 = () => {
        if (idb != "") {
            setVisible(3);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const toggleDiv4 = () => {
        if (idb != "") {
            setVisible(4);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const toggleDiv5 = () => {
        if (idb != "") {
            setVisible(5);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const toggleDiv6 = () => {
        if (idb != "") {
            setVisible(6);
        } else {
            setVisible(0);
            swal("", "Please Fill The Personal Details", "info");
        }
    }

    const AllGender = () => {
        service.GetAllGenderDropDown()
            .then((response) => {
                console.log("Gender")
                console.log(response);
                if (response.data.Status === "200") {
                    setGenderStatus(response.data.Data)
                }
                else {
                    setGenderStatus([])
                }
            })
    }

    const AllBloodGroups = () => {
        service.AllBloodGroupsDropDown()
            .then((response) => {
                console.log("Blood Group")
                console.log(response);
                if (response.data.Status === "400") {
                    setBloodGroupArr([])
                }
                else {
                    setBloodGroupArr(response.data.Data)
                }
            })
    }

    const AllMaritalStatus = () => {
        service.GetAllMaritalStatusDropDown()
            .then((response) => {
                console.log("Marital Status")
                console.log(response);
                if (response.data.Status === "200") {
                    setMaritialArr(response.data.Data)
                }
                else {
                    setMaritialArr([])
                }
            })
    }

    const AllEmployeeCategory = () => {
        service.GetEmployeeCategoryDropDown()
            .then((response) => {
                console.log("Employee Category")
                console.log(response);
                if (response.data.Status === "200") {
                    setEmpCategory(response.data.Data)
                }
                else {
                    setEmpCategory([])
                }
            })
    }

    const AllEmployeeStatus = () => {
        service.GetAllEMployeeStatusDropDown()
            .then((response) => {
                console.log("Employee Status")
                console.log(response);
                if (response.data.Status === "200") {
                    setEmpStatus(response.data.Data)
                }
                else {
                    setEmpStatus([])
                }
            })
    }

    const AllEmployeeDesignation = () => {
        service.GetAllDesignationDropDown()
            .then((response) => {
                console.log("Employee Designation")
                console.log(response);
                if (response.data.Status === "200") {
                    setDesignationArr(response.data.Data)
                }
                else {
                    setDesignationArr([])
                }
            })
    }

    const ViewAllManager = () => {
        service.GetAllReportingManagerDropDown(Id)
            .then((response) => {
                console.log("Reporting Manager")
                console.log(response);
                if (response.data.Status === "200") {
                    setManagerArr(response.data.Data)
                }
                else {
                    setManagerArr([])
                }
            })
    }

    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

    const ViewAllDepartmentunit = (id: any) => {
        // setDepartmentUnitArr([]);
        setDeapartment("");
        console.log(id, "lmlm")
        service.GetAllDepartmentUnitDropDown(id)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }

    const ViewAllProficiency = () => {
        service.ViewAllProficiencyDropDown()
            .then((response) => {
                console.log("View All Proficiency")
                console.log(response);
                if (response.data.Status === "400") {
                    setProficiencyArr([])
                }
                else {
                    setProficiencyArr(response.data.Data)
                }
            })
    }

    const ViewAllBoard = () => {
        service.ViewAllBoardDropDown()
            .then((response) => {
                console.log("Board")
                console.log(response);
                if (response.data.Status === "400") {
                    setXBoardArr([]);
                }
                else {
                    setXBoardArr(response.data.Data)
                }
            })
    }

    useEffect(() => {
        AllGender();
        AllBloodGroups();
        AllMaritalStatus();
        AllEmployeeCategory();
        AllEmployeeStatus();
        AllEmployeeDesignation();
        ViewAllManager();
        ViewAllBusinessunit();
        // ViewAllDepartmentunit("");
        ViewAllProficiency();
        ViewAllBoard();
    }, [])


    const handleGenderChange = (e: any) => {
        setGender(e.target.value)
    }

    const handleBloodGrouprChange = (e: any) => {
        setBloodGroup(e.target.value)
    }

    const handleMaritalChange = (e: any) => {
        setMaritialStatus(e.target.value)
    }

    const handleCategoryChange = (e: any) => {
        setCategory(e.target.value)
    }

    const handleEmployeeStatusChange = (e: any) => {
        setEmployeestatus(e.target.value)
    }

    const handleDesignationChange = (e: any) => {
        setDesignation(e.target.value)
    }

    const handleRoleStatusChange = (e: any) => {
        var role = e.target.value;
        if (role === "1") {
            setRole("1")
        }
        else if (role === "2") {
            setRole("2")
        }
        else if (role === "3") {
            setRole("3")
        }
        else if (role === "4") {
            setRole("4");
        }
        else if (role === "5") {
            setRole("5");
        }
        else if (role === "6") {
            setRole("6");
        }
    }

    const handleReportChange = (e: any) => {
        setReportingPerson(e.target.value)
    }

    const handleBoardChange = (e: any) => {
        setXthboard(e.target.value);
    }

    const handleBusinessUnitChange = (e: any) => {
        setBusiness(e.target.value)
        ViewAllDepartmentunit(e.target.value)
    }

    const handleDepartmentUnitChange = (e: any) => {
        setDeapartment(e.target.value)
    }

    const handleCoverageName = (e: any, i: any) => {
        coverage[i].coverageName = e.target.value
    }
    const handleCoverageRelationship = (e: any, i: any) => {
        coverage[i].relationship = e.target.value
    }

    const SameAsPro = (e: any) => {
        if (e.target.checked === true) {
            setChe(true)
            setPerAddressline1(addressline1);
            setPerAddressline2(addressline2);
            setPerAddressline3(addressline3);
            setPerAddressline4(addressline4);
        }
        else {
            setChe(false)
            setPerAddressline1('');
            setPerAddressline2('');
            setPerAddressline3('');
            setPerAddressline4('');
        }
    }

    /*............Add VAlue in Mapping ............ */
    const addmoreCollege = () => {
        var valSet = isFoundCollege('');
        if (!valSet) {
            setCollegeMap([...collegeMap, { instituteName: "", university: "", degree: "", coreSubjects: "", yearOfPassing: "", gpa: "" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const addmoreSkill = () => {
        var valSet = isFoundSkill('');
        if (!valSet) {
            setTechskillMap([...techskillMap, { technicalSkills: "", proficiency: "", yearsOfExperience: "", }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const addmoreCertificate = () => {
        var valSet = isFoundCertificate('');
        if (!valSet) {
            setCertificateMap([...certificateMap, { certificateName: "", descriptions: "", issuedBy: "", validity: "" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const addmoreEmployment = () => {
        var valSet = isFoundEmployment('');
        if (!valSet) {
            setEmployeeDetailMap([...employmentDetailMap, { organization: "", designation: "", startyear: "", endyear: "" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const addmoreCoverage = () => {
        var valSet = isFoundCoverage('');
        if (!valSet) {
            setCoverage([...coverage, { coverageName: "", relationship: "" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const isFoundCollege = (val: any) => {
        return collegeMap.some((item: any) => (val === item.instituteName || val === item.university || val === item.degree || val === item.coreSubjects || val === item.yearOfPassing || val === item.gpa));
    }

    const isFoundSkill = (val: any) => {
        return techskillMap.some((item: any) => (val === item.technicalSkills || val === item.proficiency || val === item.yearsOfExperience));
    }

    const isFoundCertificate = (val: any) => {
        return certificateMap.some((item: any) => (val === item.certificateName || val === item.descriptions || val === item.issuedBy || val === item.validity));
    }

    const isFoundCoverage = (val: any) => {
        return coverage.some((item: any) => (val === item.coverageName || val === item.relationship));
    }

    const isFoundEmployment = (val: any) => {
        return employmentDetailMap.some((item: any) => (val === item.organization || val === item.designation || val === item.startyear || val === item.endyear));
    }

    /*..........Mapping Values Handle ........... */
    const handleInstitute = (e: any, i: any) => {
        collegeMap[i].instituteName = e.target.value
    }

    const handleUniversity = (e: any, i: any) => {
        collegeMap[i].university = e.target.value
    }

    const handleDegree = (e: any, i: any) => {
        collegeMap[i].degree = e.target.value
    }

    const handleSubject = (e: any, i: any) => {
        collegeMap[i].coreSubjects = e.target.value
    }

    const handleYear = (e: any, i: any) => {
        collegeMap[i].yearOfPassing = e.target.value
    }

    const handleGpa = (e: any, i: any) => {
        collegeMap[i].gpa = e.target.value
    }

    const handleOrganization = (e: any, i: any) => {
        employmentDetailMap[i].organization = e.target.value
    }
    // const handleDesignation = (e: any, i: any) => {
    //     employmentDetailMap[i].designation = e.target.value
    // }
    const handlestartyear = (e: any, i: any) => {
        employmentDetailMap[i].startyear = e.target.value
    }
    const handleendyear = (e: any, i: any) => {
        employmentDetailMap[i].endyear = e.target.value
    }

    const handleTechskill = (e: any, i: any) => {
        techskillMap[i].technicalSkills = e.target.value
    }
    const handleProviciency = (e: any, i: any) => {
        techskillMap[i].proficiency = e.target.value
    }
    const handleYears = (e: any, i: any) => {
        techskillMap[i].yearsOfExperience = parseInt(e.target.value, 10)
    }
    const handleCertificatename = (e: any, i: any) => {
        certificateMap[i].certificateName = e.target.value
    }
    const handleDescription = (e: any, i: any) => {
        certificateMap[i].descriptions = e.target.value
    }
    const handleIssuedby = (e: any, i: any) => {
        certificateMap[i].issuedBy = e.target.value
    }
    const handleValidity = (e: any, i: any) => {
        certificateMap[i].validity = e.target.value
    }

    const PersonalSave = () => {
        let email1 = (email).split("@")

        if (email === "") {
            swal("", "Please enter Infocareer Email Id", "info");
        }
        else if (mailPat.test(email) === false) {
            swal("", "Please enter Vaild Email Id", "info");
        }
        else if (email1[1] != "infocareerindia.com") {
            swal("", "Email Id ends with only infocareerindia.com", "info");
        }
        else if (doj === "") {
            swal("", "Please enter Date of Joining", "info");
        }
        else if (name === "") {
            swal("", "Please Enter First Name", "info");
        }
        else if (name.charAt(0) === " ") {
            swal("", "Empty Space at Name", "info");
        }
        else if (namepat.test(name) === false) {
            swal("", "Alphabets only Allowed in Name", "info");
        }
        else if (lastname === "") {
            swal("", "Please Enter Last Name", "info");
        }
        else if (lastname.charAt(0) === " ") {
            swal("", "Empty Space at Last Name", "info");
        }
        else if (namepat.test(lastname) === false) {
            swal("", "Alphabets only Allowed in Name", "info");
        }
        else if (gender.length === 0) {
            swal("", "Please Select Gender", "info");
        }
        else if (DOB === "") {
            swal("", "Please enter Date Of Birth", "info");
        }
        // else if (phone.length != 0 && phone.length != 10) {
        //     swal("", "Please Valid Land Line Number", "info");
        // }
        else if (mobile === "") {
            swal("", "Please enter Mobile Number", "info");
        }
        else if (mobile.length != 10) {
            swal("", "Enter Valid Mobile Number", "info");
        }
        else if (bloodGroup.length === 0) {
            swal("", "Please enter Blood Group", "info");
        }
        else if (martialStatus.length === 0) {
            swal("", "Please Select Maritial Status", "info");
        }
        else if (Location === "") {
            swal("", "Please enter Employee Location", "info");
        }
        else if (designation.length === 0) {
            swal("", "Please Select Employee Designation", "info");
        }
        else if (category.length === 0) {
            swal("", "Please Select Employee Categary", "info");
        }
        else if (employeeStatus.length === 0) {
            swal("", "Please Select Employee Status", "info");
        }
        else if (role === "") {
            swal("", "Please Select Employee Role", "info");
        }
        else if (fathername === "") {
            swal("", "Please enter Father Name", "info");
        }
        else if (fathername.charAt(0) === " ") {
            swal("", "Empty Space at Name", "info");
        }
        else if (namepat.test(fathername) === false) {
            swal("", "Alphabets only Allowed in Father Name", "info");
        }
        else if (contact === "") {
            swal("", "Please enter Employee Emergency Contact Number", "info");
        }
        else if (contact.length != 10) {
            swal("", "Enter Valid Emergency Contact Number", "info");
        }
        else if (ERelationship === "") {
            swal("", "Please enter Employee Emergency Contact Relationship", "info");
        }
        else if (personalemail === "") {
            swal("", "Please enter Personal Email Id", "info");
        }
        else if (mailPat.test(personalemail) === false) {
            swal("", "Please enter Vaild Personal Email Id", "info");
        }
        else if (addressline1 === "") {
            swal("", "Please enter Current Address", "info");
        }
        else if (addressline1.charAt(0) === " ") {
            swal("", "Empty Space at Current Address", "info");
        }
        else if (addressline3 === "") {
            swal("", "Please enter City & State in Current Address", "info");
        }
        else if (addressline4 === "") {
            swal("", "Please enter Pincode in Current Address", "info");
        }
        else if (addressline4.length != 6) {
            swal("", "Please enter Valid Pincode in Current Address", "info");
        }
        else if (Peraddressline1 === "") {
            swal("", "Please enter Permanant Address", "info");
        }
        else if (Peraddressline1.charAt(0) === " ") {
            swal("", "Empty Space at Permanant Address", "info");
        }
        else if (Peraddressline3 === "") {
            swal("", "Please enter City & State in Permanant Address", "info");
        }
        else if (Peraddressline4 === "") {
            swal("", "Please enter Pincode in Permanant Address", "info");
        }
        else if (Peraddressline4.length != 6) {
            swal("", "Please enter Valid Pincode in Permanant Address", "info");
        }
        else {
            service.EmployeePersonalSaveOrUpdate(name, fathername, martialStatus, DOB, category, employeeStatus, gender, bloodGroup, mobile, contact, ERelationship, Location, Peraddressline1, Peraddressline2, Peraddressline3, Peraddressline4, addressline1, addressline2, addressline3, addressline4, empCode, doj, idb, phone, role, email, designation, lastname, personalemail,status)
                .then((response) => {
                    console.log(response);
                    if (response.data.status === "405") {
                        swal("", response.data.message, "info");
                    }
                    else {
                        setData(response.data.Data);
                        setidb(response.data.Data.id)
                        if (response.data.Data.name != null || response.data.Data.name != "") {
                            setFirst(response.data.Data.name);
                        }
                        else {
                            setFirst("")
                        }
                        if (response.data.Data.lastName != null || response.data.Data.lastName != "") {
                            setLast(response.data.Data.lastName);
                        }
                        else {
                            setLast("");
                        }
                        console.log("Employee Id", idb)
                        swal("", "Saved succefully", "success");
                        setVisible(1);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }

    const EduSave = () => {
        console.log("sdfghjkl", idb);
        if (xthinstitute === "") {
            swal("", "Please Enter InstitutionName", "info");
        }
        else if (xthpassyear === "") {
            swal("", "Please Enter Passing Year", "info");
        }
        else if (xthboard.length === 0) {
            swal("", "Please Select Board", "info");
        }
        else if (xthpercentage === "") {
            swal("", "Please Enter Pass Percentage", "info");
        }
        else if (xiithinstitute === "") {
            swal("", "Please Enter InstitutionName", "info");
        }
        else if (xiithpassyear === "") {
            swal("", "Please Enter Passing Year", "info");
        }
        else if (xiithcoresubject === "") {
            swal("", "Please Enter Core Subject", "info");
        }
        else if (xiithpercentage === "") {
            swal("", "Please Enter Pass Percentage", "info");
        }
        else {
            var instituteName;
            var university;
            var degree;
            var coreSubjects;
            var yearOfPassing;
            var gpa;
            for (let i = 0; i < collegeMap.length; i++) {
                if (collegeMap[i].instituteName === "") {
                    instituteName = ""
                }
                if (collegeMap[i].university === "") {
                    university = ""
                }
                if (collegeMap[i].degree === "") {
                    degree = ""
                }
                if (collegeMap[i].coreSubjects === "") {
                    coreSubjects = ""
                }
                if (collegeMap[i].yearOfPassing === "") {
                    yearOfPassing = ""
                }
                if (collegeMap[i].gpa === "") {
                    gpa = ""
                }
            }

            if (instituteName === "") {
                swal("", "Please Enter College InstitutionName", "info");
            }
            else if (university === "") {
                swal("", "Please Enter University Name", "info");
            }
            else if (degree === "") {
                swal("", "Please Enter Degree", "info");
            }
            else if (coreSubjects === "") {
                swal("", "Please Enter Core Subjects", "info");
            }
            else if (yearOfPassing === "") {
                swal("", "Please Enter Year of Passing", "info");
            }
            else if (gpa === "") {
                swal("", "Please Enter GPA", "info");
            }
            else {
                service.EmployeeEducationalSaveOrUpdate(xthinstitute, xthpassyear, xthboard, xthpercentage, xiithinstitute, xiithpassyear, xiithcoresubject, xiithpercentage, collegeMap, idb,status)
                    .then((res: { status: number; data: any }) => {
                        console.log(res);
                        if (res.status == 200) {
                            setData(res.data);
                            console.log("===============>", data)
                            swal("", "Saved Successfully", "success")
                            toggleDiv6();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
        }
    }

    const EmploymentSave = () => {
        if (idb === "") {
            swal("", "Please enter InstitutioName", "info");
        }
        else {
            var organization;
            var designation;
            var startyear;
            var endyear;

            for (let i = 0; i < employmentDetailMap.length; i++) {
                if (employmentDetailMap[i].organization === "") {
                    organization = "";
                }
                if (employmentDetailMap[i].designation === "") {
                    designation = "";
                }
                if (employmentDetailMap[i].startyear === "") {
                    startyear = "";
                }
                if (employmentDetailMap[i].endyear === "") {
                    endyear = "";
                }
            }

            if (organization === "") {
                swal("", "Please Enter organization", "info");
            }
            else if (designation === "") {
                swal("", "Please Enter Designation", "info");
            }
            else if (startyear === "") {
                swal("", "Please Enter Start Year", "info");
            }
            else if (endyear === "") {
                swal("", "Please Enter End Year", "info");
            }
            else {
                service.EmployeeEmployementSaveOrUpdate(idb, employmentDetailMap,status)
                    .then((res: { status: number; data: any }) => {
                        console.log(res);
                        if (res.status == 200) {
                            setData(res.data);
                            console.log("===============>", data)
                            swal("", "Saved Successfully", "success")
                            history.push("/HREmployees")
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
        }
    }

    const SkillSave = () => {
        if (idb === "") {
            swal("", "Please enter InstitutioName", "info");
        }
        else {
            var technicalSkills;
            var proficiency;
            var yearsOfExperience;
            var certificateName;
            var descriptions;
            var issuedBy;
            var validity;
            for (let i = 0; i < techskillMap.length; i++) {
                if (techskillMap[i].technicalSkills === "") {
                    technicalSkills = ""
                }
                if (techskillMap[i].proficiency === "") {
                    proficiency = ""
                }
                if (techskillMap[i].yearsOfExperience === "") {
                    yearsOfExperience = ""
                }
            }
            for (let i = 0; i < certificateMap.length; i++) {
                if (certificateMap[i].certificateName === "") {
                    certificateName = ""
                }
                if (certificateMap[i].descriptions === "") {
                    descriptions = ""
                }
                if (certificateMap[i].issuedBy === "") {
                    issuedBy = ""
                }
                if (certificateMap[i].validity === "") {
                    validity = ""
                }
            }


            if (technicalSkills === "") {
                swal("", "Please Enter TechnicalSkill", "info");
            }
            else if (proficiency === "") {
                swal("", "Please Enter Proficiency", "info");
            }
            else if (yearsOfExperience === "") {
                swal("", "Please Enter Years Of Experience ", "info");
            }
            else if (certificateName === "") {
                swal("", "Please Enter Certificate Name ", "info");
            }
            else if (descriptions === "") {
                swal("", "Please Enter Description ", "info");
            }
            else if (issuedBy === "") {
                swal("", "Please Enter IssuedBy Details", "info");
            }
            else if (validity === "") {
                swal("", "Please Enter Validity Details", "info");
            }
            else {
                service.EmployeeSkillSaveOrUpdate(techskillMap, idb, certificateMap,status)
                    .then((res) => {
                        console.log(res);
                        if (res.status == 200) {
                            setData(res.data);
                            console.log("===============>", data)
                            swal("", "Saved Successfully", "success");
                            toggleDiv5()
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
        }
    }

    const PersonalIdentiSave = () => {
        if (aadhaar === "") {
            swal("", "Please Enter Aadhar Number", "info");
        }
        else if (aadhaar === "") {
            swal("", "Please Enter Aadhar Number", "info");
        }
        else if (panNo === "") {
            swal("", "Please Enter Pan Number", "info");
        }
        else if (passport === "") {
            swal("", "Please Enter Passport Number", "info");
        }
        else {
            service.EmployeeIdentiteSaveOrUpdate(panNo, passport, aadhaar, passportValidity, idb,status)
                .then((res) => {
                    console.log(res);
                    if (res.status == 200) {
                        setData(res.data);
                        console.log("===============>", data)
                        swal("", "Saved Successfully", "success")
                        toggleDiv3();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }

    const StatutorySave = () => {
        // if (pfNo === "") {
        //     swal("", "Please Enter PF Number", "info");
        // }
        // else if (esiNo === "") {
        //     swal("", "Please Enter ESI Number", "info");
        // }
        // if (insurance === "") {
        //     swal("", "Please Enter Insurence Number", "info");
        // }
        // else if (insuranceValidity === "") {
        //     swal("", "Please Enter Insurence Validity", "info");
        // }
        // else {
        //     var name;
        //     var relationship;
        //     for (let i = 0; i < coverage.length; i++) {
        //         if (coverage[i].coverageName === "") {
        //             name = ""
        //         }
        //         if (coverage[i].relationship === "") {
        //             relationship = "";
        //         }
        //     }
            // if (name = "") {
            //     swal("", "Please Enter Insurence Coverage Name", "info");
            // }
            // else if (relationship = "") {
            //     swal("", "Please Enter Insurence Coverage Relationship", "info");
            // }
            // else {
                service.EmployeeStatutorySaveOrUpdate(pfNo, esiNo, insurance, insuranceValidity, coverage, idb,status)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 200) {
                            setData(res.data);
                            console.log("===============>", data)
                            swal("", "Saved Successfully", "success")
                            toggleDiv4();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            // }
        // }
    }

    const EmployeeSave = () => {
        if (business === "") {
            swal("", "Please Select Your Business Unit", "info")
        }
        else if (department === "") {
            swal("", "Please Select Your Department Unit", "info")
        }
        else if (email === "") {
            swal("", "Please Enter Your Email Id", "info")
        }
        else if (role === "") {
            swal("", "Please Select Your Role", "info");
        }
        else if (reportingPerson.length === 0) {
            swal("", "Please Select Your Reporting Manager", "info");
        }
        else {
            service.EmployeeDetailsSaveOrUpdate(business, department, reportingPerson, idb,status)
                .then((res) => {
                    console.log(res);
                    if (res.status === 200) {
                        setData(res.data);
                        console.log("===============>", data)
                        swal("", "Saved Successfully", "success");
                        toggleDiv2()
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }

    const RemoveCollege = (item: any) => {
        const rows = [...collegeMap]
        var index = collegeMap.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setCollegeMap(rows);
    }

    const RemoveEmployementDetails = (item: any) => {
        const rows = [...employmentDetailMap]
        var index = employmentDetailMap.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setEmployeeDetailMap(rows);
    }

    const RemoveSkills = (item: any) => {
        const rows = [...techskillMap]
        var index = techskillMap.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setTechskillMap(rows);
    }

    const RemoveCertificate = (item: any) => {
        const rows = [...certificateMap]
        var index = certificateMap.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setCertificateMap(rows);
    }

    const RemoveCoverage = (item: any) => {
        const rows = [...coverage]
        var index = coverage.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setCoverage(rows);
    }

    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer" }} /> New Employee</h3>
                            </div>
                        </div>
                    </div>
                    <div className="card tab-box">
                        <div className="row user-tabs">
                            <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                    <li className="nav-item"><a onClick={() => toggleDiv()} data-bs-toggle="tab" className={visible === 0 ? "nav-link active" : "nav-link"}>Personal Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv1()} data-bs-toggle="tab" className={visible === 1 ? "nav-link active" : "nav-link"}>Organization Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv2()} data-bs-toggle="tab" className={visible === 2 ? "nav-link active" : "nav-link"}>Identification (KYC)</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv3()} data-bs-toggle="tab" className={visible === 3 ? "nav-link active" : "nav-link"}>Statutory Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv4()} data-bs-toggle="tab" className={visible === 4 ? "nav-link active" : "nav-link"}>Skill Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv5()} data-bs-toggle="tab" className={visible === 5 ? "nav-link active" : "nav-link"}>Educational Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv6()} data-bs-toggle="tab" className={visible === 6 ? "nav-link active" : "nav-link"}>Employment Details</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content" style={{ padding: "0px" }}>
                        {visible === 0 ?
                            <div className="pro-overview tab-pane fade show active">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Personal Information</h5>
                                    </div>
                                    <div className="modal-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Infocareer Email Id <span className="text-danger">*</span></label>
                                                                    <IonInput value={email} onIonChange={(e: any) => setEmail(e.detail.value)} type="text" className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Employee DOJ <span className="text-danger">*</span></label>
                                                                    <IonInput onKeyDown={(e) => e.preventDefault()} value={doj} onIonChange={(e: any) => setDoj(e.detail.value)} type="date" className="form-control" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>First Name <span className="text-danger">*</span></label>
                                                                <IonInput value={name} onIonChange={(e: any) => setName(e.detail.value)} type="text" className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Last Name <span className="text-danger">*</span></label>
                                                                <IonInput value={lastname} onIonChange={(e: any) => setLastname(e.detail.value)} type="text" className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Gender <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select" value={gender}
                                                                        onChange={(e) => handleGenderChange(e)}>
                                                                        <option value="" disabled selected>Select Gender</option>
                                                                        {genderStatus.map((state: any) => (
                                                                            <option key={state.id} value={state.id}>
                                                                                {state.gender}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>DOB <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <IonInput value={DOB} onKeyDown={(e) => e.preventDefault()} onIonChange={(e: any) => setDOB(e.detail.value)} className="form-control datetimepicker" type="date" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Land Line</label>
                                                                <IonInput value={phone} onIonChange={(e: any) => setPhone(e.detail.value)}
                                                                    type="tel"
                                                                    inputMode="tel"
                                                                    pattern="[0-9]{10}"
                                                                    maxlength={10} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Mobile <span className="text-danger">*</span></label>
                                                                <IonInput value={mobile} onIonChange={(e: any) => setMobile(e.detail.value)}
                                                                    type="tel"
                                                                    inputMode="tel"
                                                                    pattern="[0-9]{10}"
                                                                    maxlength={10} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Blood Group <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select" value={bloodGroup}
                                                                        onChange={(e) => handleBloodGrouprChange(e)}>
                                                                        <option value="" disabled selected>Select Blood Group</option>
                                                                        {bloodGroupArr.map((state: any) => (
                                                                            <option key={state.id} value={state.value}>
                                                                                {state.bloodGroup}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Marital Status <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select"
                                                                        value={martialStatus}
                                                                        onChange={(e) => handleMaritalChange(e)}>
                                                                        <option value="" disabled selected>Select Marital Status</option>
                                                                        {martialArr.map((state: any) => (
                                                                            <option key={state.id} value={state.id}>
                                                                                {state.status}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Employee Location <span className="text-danger">*</span></label>
                                                                <IonInput value={Location} onIonChange={(e: any) => setLocation(e.detail.value)} type="text" className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Designation <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <Select

                                                                        options={option3}
                                                                        value={option3.find((option) => option.value === designation) || null}
                                                                        onChange={handleDesignation}
                                                                        onInputChange={handleInputChange3}
                                                                        onMenuOpen={handleMenuOpen3}
                                                                        onMenuClose={handleMenuClose3}
                                                                        onFocus={handleFocus3}
                                                                        onBlur={handleBlur3}
                                                                        menuIsOpen={menuIsOpen3}
                                                                        isSearchable
                                                                        placeholder={<Placeholder3 />}
                                                                        components={{
                                                                            DropdownIndicator: DropdownIndicator3,
                                                                        }}
                                                                        className="custom-select6"
                                                                    />
                                                                    {/* <select className="select"
                                                                        value={designation}
                                                                        onChange={(e) => handleDesignationChange(e)}>
                                                                        <option value="" disabled selected>Select Designation</option>
                                                                        {designationArr.map((state: any) => (
                                                                            <option key={state.id} value={state.id}>
                                                                                {state.designationName}
                                                                            </option>
                                                                        ))}
                                                                    </select> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Employee Category <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select"
                                                                        value={category}
                                                                        onChange={(e) => handleCategoryChange(e)}>
                                                                        <option value="" disabled selected>Select Employee Category</option>
                                                                        {empCategory.map((state: any) => (
                                                                            <option key={state.id} value={state.id}>
                                                                                {state.employmentTypesName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Employee Status <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select"
                                                                        value={employeeStatus}
                                                                        onChange={(e) => handleEmployeeStatusChange(e)}>
                                                                        <option value="" disabled selected>Select Employee Status</option>
                                                                        {empStatus.map((state: any) => (
                                                                            <option key={state.id} value={state.id}>
                                                                                {state.employeeStatus}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Access Role <span className="text-danger">*</span></label>
                                                                <div>
                                                                    <select className="select"
                                                                        value={role}
                                                                        onChange={(e) => handleRoleStatusChange(e)}>
                                                                        <option value="" disabled selected>Select Access Role</option>
                                                                        <option value="1">ADMIN</option>
                                                                        <option value="2">MANAGER</option>
                                                                        <option value="3">TEAM LEADER</option>
                                                                        <option value="4">TEAM MEMBER</option>
                                                                        <option value="5">BUSINESS UNIT HEAD</option>
                                                                        <option value="6">DEPARTMENT UNIT HEAD</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Father Name <span className="text-danger">*</span></label>
                                                                <IonInput value={fathername} onIonChange={(e: any) => setFathername(e.detail.value)} type="text" className="form-control" defaultValue="Doe" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Emergency Contact <span className="text-danger">*</span></label>
                                                                <IonInput value={contact} onIonChange={(e: any) => setContact(e.detail.value)}
                                                                    type="tel"
                                                                    inputMode="tel"
                                                                    pattern="[0-9]{10}"
                                                                    maxlength={10} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Emergency Contact Relationship <span className="text-danger">*</span></label>
                                                                <IonInput value={ERelationship} onIonChange={(e: any) => setERelationship(e.detail.value)} type="text" className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">

                                                                <label>Personal Email id <span className="text-danger">*</span></label>
                                                                <IonInput value={personalemail} onIonChange={(e: any) => setPersonalEmail(e.detail.value)} type="text" className="form-control" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Current Address <span className="text-danger">*</span></label>
                                                        <IonInput value={addressline1} placeholder="Address Line 1" onIonChange={(e: any) => setAddressline1(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={addressline2} placeholder="Address Line 2" onIonChange={(e: any) => setAddressline2(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={addressline3} placeholder="City & State" onIonChange={(e: any) => setAddressline3(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={addressline4} placeholder="Pincode" onIonChange={(e: any) => setAddressline4(e.detail.value)} type="number" onKeyDown={(evt: any) => evt.key === '.' && evt.preventDefault()} className="form-control" style={{ margin: "5px" }} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group" style={{ padding: "5px" }}>
                                                        <div style={{ display: "flex", width: "100%" }}>
                                                            <label style={{ width: "70%" }}>Permanent Address <span className="text-danger">*</span></label>
                                                            <span style={{ display: "flex" }}>
                                                                <IonCheckbox checked={che} onIonChange={(e: any) => SameAsPro(e)}></IonCheckbox>
                                                                <label style={{ paddingLeft: "5px" }}>Same As Current</label>
                                                            </span>
                                                        </div>
                                                        <IonInput value={Peraddressline1} placeholder="Address Line 1" onIonChange={(e: any) => setPerAddressline1(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={Peraddressline2} placeholder="Address Line 2" onIonChange={(e: any) => setPerAddressline2(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={Peraddressline3} placeholder="City & State" onIonChange={(e: any) => setPerAddressline3(e.detail.value)} type="text" className="form-control" style={{ margin: "5px" }} />
                                                        <IonInput value={Peraddressline4} placeholder="Pincode" onIonChange={(e: any) => setPerAddressline4(e.detail.value)} type="number" onKeyDown={(evt: any) => evt.key === '.' && evt.preventDefault()} className="form-control" style={{ margin: "5px" }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="submit-section">
                                                <button onClick={() => PersonalSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            :
                            visible === 1 ?
                                <div className="pro-overview tab-pane fade show active">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Organization Information</h5>
                                        </div>
                                        <div className="modal-body">
                                            <form>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>First Name </label>
                                                                    <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Last Name </label>
                                                                    <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Business Unit <span className="text-danger">*</span></label>
                                                                    <div>
                                                                        <Select

                                                                            options={options}
                                                                            value={options.find((option) => option.value === business) || null}
                                                                            onChange={handleBusinessChange}
                                                                            onInputChange={handleInputChange}
                                                                            onMenuOpen={handleMenuOpen}
                                                                            onMenuClose={handleMenuClose}
                                                                            onFocus={handleFocus}
                                                                            onBlur={handleBlur}
                                                                            menuIsOpen={menuIsOpen}
                                                                            isSearchable
                                                                            placeholder={<Placeholder />}
                                                                            components={{
                                                                                DropdownIndicator: DropdownIndicator,
                                                                            }}
                                                                            className="custom-select6"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Department Unit <span className="text-danger">*</span></label>
                                                                    <div>
                                                                        <Select

                                                                            options={option1}
                                                                            value={option1.find((option) => option.value === department) || null}
                                                                            onChange={handleDeptChange}
                                                                            onInputChange={handleInputChange1}
                                                                            onMenuOpen={handleMenuOpen1}
                                                                            onMenuClose={handleMenuClose1}
                                                                            onFocus={handleFocus1}
                                                                            onBlur={handleBlur1}
                                                                            menuIsOpen={menuIsOpen1}
                                                                            isSearchable
                                                                            placeholder={<Placeholder1 />}
                                                                            components={{
                                                                                DropdownIndicator: DropdownIndicator1,
                                                                            }}
                                                                            className="custom-select6"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Reporting Manager <span className="text-danger">*</span></label>
                                                                    <div>
                                                                        <Select

                                                                            options={option2}
                                                                            value={option2.find((option) => option.value === reportingPerson) || null}
                                                                            onChange={handleManagerChange}
                                                                            onInputChange={handleInputChange2}
                                                                            onMenuOpen={handleMenuOpen2}
                                                                            onMenuClose={handleMenuClose2}
                                                                            onFocus={handleFocus2}
                                                                            onBlur={handleBlur2}
                                                                            menuIsOpen={menuIsOpen2}
                                                                            isSearchable
                                                                            placeholder={<Placeholder2 />}
                                                                            components={{
                                                                                DropdownIndicator: DropdownIndicator2,
                                                                            }}
                                                                            className="custom-select6"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="submit-section">
                                                <button onClick={() => EmployeeSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                visible === 2 ?
                                    <div className="pro-overview tab-pane fade show active">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Identification Information</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>First Name </label>
                                                                        <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>Last Name </label>
                                                                        <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>AADHAAR No </label>
                                                                        <IonInput value={aadhaar} onIonChange={(e: any) => setAadhaar(e.detail.value)} className="form-control"
                                                                            type="tel"
                                                                            inputMode="tel"
                                                                            pattern="[0-9]{10}"
                                                                            maxlength={12} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>PAN No </label>
                                                                        <IonInput value={panNo} onIonChange={(e: any) => setPanNo(e.detail.value)} className="form-control"
                                                                            type="tel"
                                                                            inputMode="tel"
                                                                            pattern="[0-9]{10}"
                                                                            maxlength={10} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>Passport No </label>
                                                                        <IonInput value={passport} onIonChange={(e: any) => setPassPort(e.detail.value)} type="text" className="form-control" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>Passport Validity </label>
                                                                        <IonInput value={passportValidity} onIonChange={(e: any) => setPassPortvalidity(e.detail.value)} type="text" className="form-control" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="submit-section">
                                                        <button onClick={() => PersonalIdentiSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    visible === 3 ?
                                        <div className="pro-overview tab-pane fade show active">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Statutory Information</h5>
                                                </div>
                                                <div className="modal-body">
                                                    <form>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>First Name </label>
                                                                            <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Last Name </label>
                                                                            <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>PF No </label>
                                                                            <IonInput value={pfNo} onIonChange={(e: any) => setPfNo(e.detail.value)} type="text" className="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>ESI No </label>
                                                                            <IonInput value={esiNo} onIonChange={(e: any) => setEsiNo(e.detail.value)} type="text" className="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Group Insurance Details </label>
                                                                            <IonInput value={insurance} onIonChange={(e: any) => setInsurance(e.detail.value)} type="text" className="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Insurance Expiry Date </label>
                                                                            <IonInput value={insuranceValidity} onIonChange={(e: any) => setInsuranceValidity(e.detail.value)} type="date" className="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        {coverage.map((item: any, i: any) => (
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label>Coverage Name </label>
                                                                                        <IonInput value={item.coverageName} onIonChange={(e: any) => handleCoverageName(e, i)} type="text" className="form-control" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-5">
                                                                                    <div className="form-group">
                                                                                        <label>Relationship </label>
                                                                                        <IonInput value={item.relationship} onIonChange={(e: any) => handleCoverageRelationship(e, i)} type="text" className="form-control" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-1">
                                                                                    <div className="form-group" style={{ marginTop: "25px" }}>
                                                                                        <button onClick={() => RemoveCoverage(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{ display: "flex" }}>
                                                            <button onClick={() => addmoreCoverage()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                                                        </div>
                                                    </form>
                                                    <div className="submit-section">
                                                        <button onClick={() => StatutorySave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        visible === 4 ?
                                            <div className="pro-overview tab-pane fade show active">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Skill Information</h5>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>First Name </label>
                                                                    <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Last Name </label>
                                                                    <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h3 className="card-title" style={{ color: "coral" }}>Technical Skills</h3>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {techskillMap.map((item: any, i: any) => (
                                                                        <div className="row">
                                                                            <div className="col-md-4">
                                                                                <div className="form-group">
                                                                                    <label>Technical Skills </label>
                                                                                    <IonInput value={item.technicalSkills} onIonChange={(e: any) => handleTechskill(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <div className="form-group">
                                                                                    <label>Proficiency </label>
                                                                                    <div>
                                                                                        <select className="select"
                                                                                            onChange={(e: any) => handleProviciency(e, i)}>
                                                                                            <option value="" disabled selected>Select Proficiency</option>
                                                                                            {proficiencyArr.map((state: any) => (
                                                                                                <option key={state.id} value={state.level}>
                                                                                                    {state.level}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <div className="form-group">
                                                                                    <label>Years of Experience </label>
                                                                                    <IonInput value={item.yearsOfExperience} onIonChange={(e: any) => handleYears(e, i)} type="number" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-1">
                                                                                <div className="form-group" style={{ marginTop: "25px" }}>
                                                                                    <button onClick={() => RemoveSkills(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <button onClick={() => addmoreSkill()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                                                            </div>
                                                        </form>
                                                        <h3 className="card-title" style={{ color: "coral" }}>Professional Certification</h3>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {certificateMap.map((item: any, i: any) => (
                                                                        <div className="row">
                                                                            <div className="col-md-3">
                                                                                <div className="form-group">
                                                                                    <label>Certificate Name </label>
                                                                                    <IonInput value={item.certificateName} onIonChange={(e: any) => handleCertificatename(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <div className="form-group">
                                                                                    <label>Description </label>
                                                                                    <IonInput value={item.descriptions} onIonChange={(e: any) => handleDescription(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3">
                                                                                <div className="form-group">
                                                                                    <label>Issued By </label>
                                                                                    <IonInput value={item.issuedBy} onIonChange={(e: any) => handleIssuedby(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>Validity </label>
                                                                                    <IonInput value={item.validity} onIonChange={(e: any) => handleValidity(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-1">
                                                                                <div className="form-group" style={{ marginTop: "25px" }}>
                                                                                    <button onClick={() => RemoveCertificate(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <button onClick={() => addmoreCertificate()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                                                            </div>
                                                        </form>
                                                        <div className="submit-section">
                                                            <button onClick={() => SkillSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            visible === 5 ?
                                                <div className="pro-overview tab-pane fade show active">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Educational Information</h5>
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>First Name </label>
                                                                        <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>Last Name </label>
                                                                        <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h3 className="card-title" style={{ color: "coral" }}>School X</h3>
                                                            <form>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Institution Name </label>
                                                                                    <IonInput value={xthinstitute} onIonChange={(e: any) => setXthinstitute(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Passing Year </label>
                                                                                    <IonInput value={xthpassyear} onIonChange={(e: any) => setXthpassyear(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Board </label>
                                                                                    <div>
                                                                                        <select className="select" value={xthboard}
                                                                                            onChange={(e) => handleBoardChange(e)}>
                                                                                            <option value="" disabled selected>Select Board</option>
                                                                                            {xboardArr.map((state: any) => (
                                                                                                <option key={state.id} value={state.value}>
                                                                                                    {state.board}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Pass Percentage </label>
                                                                                    <IonInput value={xthpercentage} onIonChange={(e: any) => setXthpercentage(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            <h3 className="card-title" style={{ color: "coral" }}>School XII</h3>
                                                            <form>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Institution Name </label>
                                                                                    <IonInput value={xiithinstitute} onIonChange={(e: any) => setXIIthinstitute(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Passing Year </label>
                                                                                    <IonInput value={xiithpassyear} onIonChange={(e: any) => setXIIthpassyear(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Core Subjects </label>
                                                                                    <IonInput value={xiithcoresubject} onIonChange={(e: any) => setXIIthcoresubject(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Pass Percentage </label>
                                                                                    <IonInput value={xiithpercentage} onIonChange={(e: any) => setXIIthpercentage(e.detail.value)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            <h3 className="card-title" style={{ color: "coral" }}>Graduation </h3>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {collegeMap.map((item: any, i: any) => (
                                                                        <div className="row">
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>Institution Name </label>
                                                                                    <IonInput value={item.instituteName} name='instituteName' onIonChange={(e: any) => handleInstitute(e, i)} className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>University </label>
                                                                                    <IonInput value={item.university} name="university" onIonChange={(e: any) => handleUniversity(e, i)} className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-1">
                                                                                <div className="form-group">
                                                                                    <label>Degree </label>
                                                                                    <IonInput value={item.degree} onIonChange={(e: any) => handleDegree(e, i)} className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>Core Subjects </label>
                                                                                    <IonInput value={item.coreSubjects} onIonChange={(e) => handleSubject(e, i)} className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>Year of Passing </label>
                                                                                    <IonInput value={item.yearOfPassing} onIonChange={(e) => handleYear(e, i)} className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <div className="form-group">
                                                                                    <label>GPA / Marks </label>
                                                                                    <IonInput value={item.gpa} onIonChange={(e) => handleGpa(e, i)} type="text" className="form-control" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-1">
                                                                                <div className="form-group" style={{ marginTop: "25px" }}>
                                                                                    <button onClick={() => RemoveCollege(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <button onClick={() => addmoreCollege()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                                                            </div>
                                                            <div className="submit-section">
                                                                <button onClick={() => EduSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                visible === 6 ?
                                                    <div className="pro-overview tab-pane fade show active">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Employment Information</h5>
                                                            </div>
                                                            <div className="modal-body">
                                                                <form>
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label>First Name </label>
                                                                                <IonInput readonly value={first} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label>Last Name </label>
                                                                                <IonInput readonly value={last} type="text" className="form-control" style={{ backgroundColor: "#DCDCDC" }} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            {employmentDetailMap.map((item: any, i: any) => (
                                                                                <div className="row">
                                                                                    <div className="col-md-3">
                                                                                        <div className="form-group">
                                                                                            <label>Organization </label>
                                                                                            <IonInput value={item.organization} onIonChange={(e: any) => handleOrganization(e, i)} type="text" className="form-control" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <div className="form-group">
                                                                                            <label>Designation </label>
                                                                                            <IonInput value={item.designation} onIonChange={(e: any) => handleDesignation(e, i)} type="text" className="form-control" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <div className="form-group">
                                                                                            <label>Start (Month & Year) </label>
                                                                                            <IonInput value={item.startyear} onIonChange={(e: any) => handlestartyear(e, i)} type="month" className="form-control" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-2">
                                                                                        <div className="form-group">
                                                                                            <label>End (Month & Year) </label>
                                                                                            <IonInput value={item.endyear} onIonChange={(e: any) => handleendyear(e, i)} type="month" className="form-control" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-1">
                                                                                        <div className="form-group" style={{ marginTop: "25px" }}>
                                                                                            <button onClick={() => RemoveEmployementDetails(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ display: "flex" }}>
                                                                        <button onClick={() => addmoreEmployment()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                                                                    </div>
                                                                </form>
                                                                <div className="submit-section">
                                                                    <button onClick={() => EmploymentSave()} type="button" className="btn btn-primary submit-btn">Submit</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : <></>
                        }
                    </div>
                </div>
            </IonContent>
        </IonPage >
    )
}

export default HRCreateEmployeee;